export default function settingsMenu ({ props, state }) {
  state.push('yoyth.settingsMenus', props.window)
};
